import { render, staticRenderFns } from "./informazioni.vue?vue&type=template&id=46b31638&scoped=true&"
import script from "./informazioni.vue?vue&type=script&lang=js&"
export * from "./informazioni.vue?vue&type=script&lang=js&"
import style0 from "./informazioni.vue?vue&type=style&index=0&id=46b31638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b31638",
  null
  
)

export default component.exports